import React from 'react'
import PropTypes from 'prop-types'

import Button from 'react-bootstrap/Button'
import Collapse from 'react-bootstrap/Collapse'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import InfoPopup from './InfoPopup'

import ProgramFilter from './ProgramFilter'
import ProgramFlagFilter from './ProgramFlagFilter'
import ProgramSorter from './ProgramSorter'

import { FLAGS, FLAG_DEFAULTS, PROGRAM_PRICINGS, PROGRAM_DURATIONS, PRIORITY_COUNTRY_CODES, SORT_ORDER_DETAILS, SORT_ORDERS } from '../constants'

function flagLabels(flags) {
  return Object.keys(flags).filter((flag) => {
    return flags[flag]
  }).map((flag) => {
    return FLAGS[flag]
  })
}

const filterDisplayText = (params, allCountries) => {
  let currentFilter = params
  let countries = allCountries.filter((country) => {
    return currentFilter.countryCode === country.country_code
  })
  let duration = currentFilter.duration
  let price = currentFilter.price
  let startYear = currentFilter.startYear
  let displayText = countries[0] ? countries[0].name : ''

  if (startYear) {
    displayText = displayText + ' ' + startYear
  }

  if (duration) {
    displayText = PROGRAM_DURATIONS[duration] + ' ' + displayText
  }

  if (price) {
    displayText = displayText + ' ' + PROGRAM_PRICINGS[price]
  }

  if (currentFilter.flags !== FLAG_DEFAULTS) {
    let labels = flagLabels(currentFilter.flags)
    if (labels.length) {
      displayText = displayText + ' (' + labels.join(', ') + ')'
    }
  }

  return displayText
}

const FilterForm = ({
  open,
  params,
  sortOrder,
  countries,
  programs,
  startYearRangeStart,
  onChange,
  onFlagChange,
  onSortOrderChange,
  onToggle,
  containerRef
}) => (
  <>
    <div className='mb-4 px-3 py-2 border border-light bg-light'>
      <Collapse in={!open}>
        {/*
            NOTE: we need this wrapper in order to keep the nav
            `display: flex` after collapse is openend.
            Otherwise our explicitly fixed css in auslandsjahr.org
            will set it to `display: block`
            and break the layout of this nav in desktop mode!
          */}
        <div className='small'>
          <Nav className='nav nav-fill align-items-center'>
            <Nav.Item className='text-left'>
              <Navbar.Text>
                <strong>Filter:</strong>&nbsp;<span>{filterDisplayText(params, countries)}</span>
              </Navbar.Text>
            </Nav.Item>
            <Nav.Item className='text-left'>
              <Navbar.Text>
                <strong>Sortierung:</strong> {SORT_ORDERS[sortOrder]}
                <InfoPopup title='Infos zur Sortierung'
                           body={SORT_ORDER_DETAILS}
                           containerRef={containerRef}/>
              </Navbar.Text>
            </Nav.Item>
            <Nav.Item className='ms-auto text-right'>
              <Button variant='outline-primary btn-block' size='sm'
                      onClick={(e) => {
                          e.preventDefault()
                          onToggle()
                      }}>
                &raquo; Filtereinstellungen ändern
              </Button>

            </Nav.Item>
          </Nav>
        </div>
      </Collapse>
      <Collapse in={open}>
        <div>
          <div className='row'>
            <div className='col-md-4 col-lg-5 mb-3 mb-lg-0'>
              <ProgramFilter onChange={onChange}
                             onToggle={onToggle}
                             open={open}
                             availableCountries={countries}
                             priorityCountryCodes={PRIORITY_COUNTRY_CODES}
                             startYearRangeStart={startYearRangeStart}
                             {...params} />

              <ProgramSorter
                onChange={onSortOrderChange}
                order={sortOrder}
                containerRef={containerRef} />
              <Button variant='outline-primary btn-block' size='sm'
                      className='me-2 mb-2'
                      onClick={(e) => {
                          e.preventDefault()
                          onToggle()
                      }}>
                &raquo; Filtereinstellungen ausblenden
              </Button>
            </div>
            <div className="col-md-8 col-lg-7 d-none d-md-block">
              <ProgramFlagFilter flags={params.flags}
                                 containerRef={containerRef}
                                 onChange={onFlagChange} />

            </div>
          </div>
        </div>
      </Collapse>
    </div>
  </>
)

FilterForm.propTypes = {
  open: PropTypes.bool,
  params: PropTypes.object,
  sortOrder: PropTypes.string,
  countries: PropTypes.array,
  programs: PropTypes.array,
  startYearRangeStart: PropTypes.number,
  onChange: PropTypes.func,
  onFlagChange: PropTypes.func,
  onSortOrderChange: PropTypes.func,
  onToggle: PropTypes.func,
  containerRef: PropTypes.object,
}

export default FilterForm
